import React from "react";
import { FollowGroupsList } from "../../../../model/branch/BranchFollowGroupsListModel";
import Loader from "../../../../widget/common/ui/Loader";
import Center from "../../../../widget/common/ui/Center";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import Div from "../../../../widget/common/ui/Div";
import { TextInline } from "../../../../widget/common/ui/Text";
import { CheckBoxRound } from "../../../../widget/common/ui/Checkbox";
import { BranchFollowGroupsContextImport } from "../../../../provider/branch/branch_follow_groups/BranchFollowGroupsContextProvider";
import NoData from "../../../../widget/common/ui/NoData";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";

const BranchFollowGroupsList = (props: {
  type?: number | undefined;
  groupList: Array<FollowGroupsList> | null;
}) => {
  const groupList: Array<FollowGroupsList> | null = props.groupList ?? null;

  const { onClickItem, selectedGroupIds, searchValue } =
    BranchFollowGroupsContextImport();

  return (
    <>
      {groupList == null ? (
        <Center className="py-3">{Loader.normal()}</Center>
      ) : groupList.length === 0 ? (
        <Center>
          <NoData />
        </Center>
      ) : (
        <Listing isModal={true}>
          {(groupList ?? []).map((group, key) => (
            <ListItem key={key} className="py-3 py-lg-4">
              <div
                role="button"
                className="d-flex align-items-center justify-content-between"
                onClick={() => onClickItem(group)}
              >
                <Div>
                  <TextInline
                    fontName="bold"
                    textColor="theme-label"
                    fontSize="16_17"
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: UtilityHelper.wrapKeyword(
                          group?.name!,
                          searchValue
                        ),
                      }}
                    />
                  </TextInline>
                </Div>
                <CheckBoxRound
                  status={selectedGroupIds.includes(group.group_id!)}
                />
              </div>
            </ListItem>
          ))}
        </Listing>
      )}
    </>
  );
};

export default BranchFollowGroupsList;
